const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0963ffcb2a691da95b00b5394868b938c339b4d7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["jogaonline@mangoweb"]={id:"0963ffcb2a691da95b00b5394868b938c339b4d7"};
      